var map = {
	"./attach-country.svg": "./src/icons/svg-ezpay/attach-country.svg",
	"./customer-service.svg": "./src/icons/svg-ezpay/customer-service.svg",
	"./dashboard.svg": "./src/icons/svg-ezpay/dashboard.svg",
	"./delete.svg": "./src/icons/svg-ezpay/delete.svg",
	"./developer.svg": "./src/icons/svg-ezpay/developer.svg",
	"./download.svg": "./src/icons/svg-ezpay/download.svg",
	"./eye-open.svg": "./src/icons/svg-ezpay/eye-open.svg",
	"./eye.svg": "./src/icons/svg-ezpay/eye.svg",
	"./file-download.svg": "./src/icons/svg-ezpay/file-download.svg",
	"./filter.svg": "./src/icons/svg-ezpay/filter.svg",
	"./financials.svg": "./src/icons/svg-ezpay/financials.svg",
	"./help-question-fill.svg": "./src/icons/svg-ezpay/help-question-fill.svg",
	"./help-question.svg": "./src/icons/svg-ezpay/help-question.svg",
	"./history-black.svg": "./src/icons/svg-ezpay/history-black.svg",
	"./icon-font-question.svg": "./src/icons/svg-ezpay/icon-font-question.svg",
	"./icon-font-warning.svg": "./src/icons/svg-ezpay/icon-font-warning.svg",
	"./language.svg": "./src/icons/svg-ezpay/language.svg",
	"./link.svg": "./src/icons/svg-ezpay/link.svg",
	"./merchant.svg": "./src/icons/svg-ezpay/merchant.svg",
	"./operation-create-payment.svg": "./src/icons/svg-ezpay/operation-create-payment.svg",
	"./operation-delete.svg": "./src/icons/svg-ezpay/operation-delete.svg",
	"./operation-detail.svg": "./src/icons/svg-ezpay/operation-detail.svg",
	"./operation-download.svg": "./src/icons/svg-ezpay/operation-download.svg",
	"./operation-edit.svg": "./src/icons/svg-ezpay/operation-edit.svg",
	"./operation-reopen.svg": "./src/icons/svg-ezpay/operation-reopen.svg",
	"./operation-submit.svg": "./src/icons/svg-ezpay/operation-submit.svg",
	"./password.svg": "./src/icons/svg-ezpay/password.svg",
	"./refund-icon.svg": "./src/icons/svg-ezpay/refund-icon.svg",
	"./retry.svg": "./src/icons/svg-ezpay/retry.svg",
	"./send-payments.svg": "./src/icons/svg-ezpay/send-payments.svg",
	"./system.svg": "./src/icons/svg-ezpay/system.svg",
	"./time_zone.svg": "./src/icons/svg-ezpay/time_zone.svg",
	"./tip-fill.svg": "./src/icons/svg-ezpay/tip-fill.svg",
	"./transactions.svg": "./src/icons/svg-ezpay/transactions.svg",
	"./upload-mark-default.svg": "./src/icons/svg-ezpay/upload-mark-default.svg",
	"./upload-mark-image.svg": "./src/icons/svg-ezpay/upload-mark-image.svg",
	"./upload-mark-link.svg": "./src/icons/svg-ezpay/upload-mark-link.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg-ezpay sync \\.svg$";